import script from "./LevelWinModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelWinModal.vue?vue&type=script&setup=true&lang=js"

import "./LevelWinModal.vue?vue&type=style&index=0&id=47fcb83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fcb83e"]])

export default __exports__